import styled from 'styled-components';

export const QuoteListContainer = styled.div`
  padding: 0 15px 20px 15px;
  background: #f8f8f8;
`;

export const QuoteList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
`;

export const QuoteListItem = styled.li`
  &:not(:first-child){
    border-top: 1px solid ${props => props.theme.color.border};
    margin-top: 20px;
  }
`;

export const ListContent = styled.section`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 20px;
  > *{
    &:first-child {
      flex: initial;
    }
    &:last-child{
      margin-left: 8px;
      text-align: right;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/features/corporate-quote/workflow/components/QuoteList/index.js